import React from "react";
import { Container } from "reactstrap";
import Slider from "react-slick";
import "../../assets/vendor/slick-master/slick/slick.scss";
import "../../assets/vendor/slick-master/slick/slick-theme.scss";
// import "~slick-carousel/slick/slick.css";//yarn added slick-carousel
// import "~slick-carousel/slick/slick-theme.css";
import TitleGroup, { Title } from "../../components/common/TitleGroup";
import FeatureOfferCard from "../../components/FeatureOfferCard";
import "./FeatureOfferSlider.scss";

import { useQuery } from "react-query";
import { ApiNames, fetchData } from "../../remote-data/fetchData";
import FakeApiEnabled, { FeaturedOffer } from "../../fakeapi";

function FeatureOfferSlider(props) {
  const settings = {
    arrows: true,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3, //4 or 5 in large screens
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  };

  // API: GET
  const { data: postData, isLoading: isPostLoading } = useQuery(
    ApiNames.FEATURED_OFFER,
    () =>
      fetchData(ApiNames.FEATURED_OFFER, {
        // pathValues: [props.spaceId],
        params: { size: 5 }
      })
  );
  // if (isPostLoading || !postData) return <Loader />;
  if (isPostLoading || !postData) return null;
  // console.log(postData && postData.data.collections[0].offers);
  /*
    id: "0df49df8-a202-4114-8d45-6a59dcac4851"
    title: "Free Bota Momo"
    artwork: "https://dev-cdn-offer.fonepay.com/offercontent/offer/a9c5b1b8db3940d49f7aa2f991687bcb"
    dealType: 2
    dealDiscount: 82
    subMerchants: [{…}]
    weight: 0
  */

  return (
    <Container>
      <TitleGroup>
        <Title title="Featured Offers" />
        {/* <SeeAllButton /> */}
      </TitleGroup>
      <Slider className="homepage-featured-offer" {...settings}>
        {postData
          ? postData.data.collections[0].offers.map(item => (
              <div key="item.id">
                <FeatureOfferCard postItem={item} />
              </div>
            ))
          : FakeApiEnabled &&
            FeaturedOffer.data.collections[0].offers.map(item => (
              <div key="item.id">
                <FeatureOfferCard postItem={item} />
              </div>
            ))}
      </Slider>
    </Container>
  );
}

export default FeatureOfferSlider;
